// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tutorial {
  min-height: calc(100vh - 6.063rem);
  padding: 2.5rem 3rem;
}
@media (max-width: 768px) {
  #tutorial {
    min-height: calc(20vh);
    padding: 1rem;
    background-color: #F7F7F7;
    margin-top: 2.5rem;
    border-top: 0.063rem solid #C9D3CC;
    margin-bottom: 6rem;
    padding-top: 2rem;
  }
  #tutorial h5 {
    font-size: 1.125rem;
    margin-bottom: 1rem;
  }
}
#tutorial .ant-collapse-item {
  border-bottom: 0.063rem solid #C9D3CC;
}
#tutorial .tutorial-title {
  padding: 1.5rem 0rem 0.75rem 1.813rem;
  border-bottom: 0.063rem solid #C9D3CC;
}
@media (max-width: 768px) {
  #tutorial .tutorial-title {
    padding: 1.5rem 0rem 0.75rem 1rem;
  }
}
#tutorial .ant-collapse-header {
  padding: 1rem 0;
}
#tutorial .ant-collapse-content-box {
  padding: 0.25rem 0;
}
#tutorial .ant-collapse-borderless {
  background-color: transparent;
}
#tutorial .ant-collapse-borderless .title-step {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.2rem;
  color: var(--primary-button-color);
  padding-right: 0.5rem;
}
#tutorial .ant-collapse-borderless .content-step {
  display: flex;
  flex-direction: column;
  font-weight: 400;
  font-size: 0.875rem;
  line-height: 1.05rem;
}
#tutorial .ant-collapse-borderless .content-step span {
  margin-bottom: 0.625rem;
}
#tutorial .ant-collapse-borderless .content-step img {
  max-width: 400;
}
@media (max-width: 768px) {
  #tutorial .ant-collapse-borderless .content-step {
    max-width: 80vw;
  }
}
#tutorial .ant-collapse-borderless svg {
  font-weight: 500;
  line-height: 120%;
  color: var(--primary-button-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/others/TutorialPanel/styles.less"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,oBAAA;AACF;AACE;EAAA;IACE,sBAAA;IACA,aAAA;IACA,yBAAA;IACA,kBAAA;IACA,kCAAA;IACA,mBAAA;IACA,iBAAA;EAEF;EATA;IAUI,mBAAA;IACA,mBAAA;EAEJ;AACF;AAlBA;EAoBI,qCAAA;AACJ;AArBA;EAwBI,qCAAA;EACA,qCAAA;AAAJ;AAEI;EAAA;IACE,iCAAA;EACJ;AACF;AA9BA;EAkCI,eAAA;AADJ;AAjCA;EAsCI,kBAAA;AAFJ;AApCA;EA0CI,6BAAA;AAHJ;AAvCA;EA6CM,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,qBAAA;AAHN;AA9CA;EAqDM,aAAA;EACA,sBAAA;EAEA,gBAAA;EACA,mBAAA;EACA,oBAAA;AALN;AArDA;EA6DQ,uBAAA;AALR;AAxDA;EAiEQ,cAAA;AANR;AASM;EAAA;IACE,eAAA;EANN;AACF;AAhEA;EA0EM,gBAAA;EACA,iBAAA;EACA,kCAAA;AAPN","sourcesContent":["#tutorial {\n  min-height: calc(100vh - 6.063rem);\n  padding: 2.5rem 3rem;\n\n  @media(max-width: @md-screen) {\n    min-height: calc(20vh);\n    padding: 1rem;\n    background-color: #F7F7F7;\n    margin-top: 2.5rem;\n    border-top: .063rem solid #C9D3CC;\n    margin-bottom: 6rem;\n    padding-top: 2rem;\n\n    h5 {\n      font-size: 1.125rem;\n      margin-bottom: 1rem;\n    }\n  }\n\n  .ant-collapse-item {\n    border-bottom: .063rem solid #C9D3CC;\n  }\n\n  .tutorial-title {\n    padding: 1.5rem 0rem .75rem 1.813rem;\n    border-bottom: .063rem solid #C9D3CC;\n\n    @media(max-width: @md-screen) {\n      padding: 1.5rem 0rem .75rem 1rem;\n    }\n\n  }\n\n  .ant-collapse-header {\n    padding: 1rem 0;\n  }\n\n  .ant-collapse-content-box {\n    padding: .25rem 0;\n  }\n\n  .ant-collapse-borderless {\n    background-color: transparent;\n\n    .title-step {\n      font-size: 1rem;\n      font-weight: 400;\n      line-height: 1.2rem;\n      color: var(--primary-button-color);\n      padding-right: .5rem;\n    }\n\n    .content-step {\n      display: flex;\n      flex-direction: column;\n\n      font-weight: 400;\n      font-size: .875rem;\n      line-height: 1.05rem;\n\n      span {\n        margin-bottom: .625rem;\n      }\n\n      img {\n        max-width: 400;\n      }\n\n      @media(max-width: @md-screen) {\n        max-width: 80vw;\n      }\n    }\n\n    svg{\n      font-weight: 500;\n      line-height: 120%;\n      color: var(--primary-button-color);\n    }\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
